import React, { useContext } from 'react';
// import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js"

import Tr from '../shared/tr';

import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import TooltipButton from '../shared/TooltipButton';
import TooltipToggleButton from '../shared/TooltipToggleButton';

import DisplayIcon from '-!svg-react-loader!../../assets/image/toolbar/display.svg';
import GalleryIcon from '-!svg-react-loader!../../assets/image/toolbar/gallery.svg';
import MarginLineIcon from '-!svg-react-loader!../../assets/image/toolbar/margin_line.svg';
import OcclusionMappingIcon from '-!svg-react-loader!../../assets/image/toolbar/occlusion_mapping.svg';
import OcclusionMappingSelectIcon from '-!svg-react-loader!../../assets/image/toolbar/occlusion_mapping_select.svg';
import OrientationAdjustIcon from '-!svg-react-loader!../../assets/image/toolbar/orientation_adjustment.svg';

import ExportIcon from '../../assets/image/toolbar/export.svg';
import MenuIcon from '../../assets/image/toolbar/menu.svg';
import InfoIcon from '../../assets/image/toolbar/info.svg';
import HelpIcon from '../../assets/image/toolbar/help.svg';

import ExportDlg from '../dialogs/ExportDlg';
import AboutDlg from '../dialogs/AboutDlg';
import BusyDlg from '../dialogs/BusyDlg';
import ImageInfoDlg from '../dialogs/ImageInfoDlg';
import { MeshName, AppStatus, ToolID } from '../shared/common';
import { AppContext } from '../App';

const theme = createMuiTheme({});
const buttonSize = 32;

const useStyles = makeStyles((theme) =>
  createStyles({
    toolbar: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'left',
      paddingBottom: 10,
      paddingTop: 10,
    },
    button: {
      background: '#ffffff',
      borderRadius: 0,
      width: 48,
      height: buttonSize,
      marginBottom: '10px!important',
      '&:hover': {
        background: 'rgba(54, 176, 201, 1)',
      },
      '&.Mui-selected': {
        color: theme.palette.action.active,
        backgroundColor: 'rgba(54, 176, 201, 1)',
      },
      '&.Mui-selected svg :not(path.not-white)': {
        fill: '#ffffff',
      },
    },
    spacer: {
      flexGrow: 1,
    },
  })
);

const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    margin: 0,
    border: 'none',
  },
}))(ToggleButtonGroup);

const ToolBar = () => {
  // const appInsights = useAppInsightsContext()
  const [aboutOpen, setAboutOpen] = React.useState(false);
  const [imageInfoOpen, setImageInfoOpen] = React.useState(false);
  const [exportOpen, setExportOpen] = React.useState(false);

  const {
    currentTool,
    setCurrentTool,
    withMarginLine,
    withBuccalBite,
    occlusalPlaneActor,
    occlusalPlaneVisible,
    normalMeshes,
    setSelectedActor,
    selectedActor,
    busyDlgProp,
    setMarginLineVisible,
    occluAvailable,
    status,
    exportAvailable
  } = useContext(AppContext);

  const handleChange = (event: React.MouseEvent<HTMLElement>, nextTool: ToolID | null) => {
    if (status !== AppStatus.Ready) {
      return;
    }

    setCurrentTool(nextTool);
    if (nextTool === ToolID.MarginLine) {
      setMarginLineVisible(true);
    } else {
      setMarginLineVisible(false);
    }
    //appInsights.trackEvent({ name: 'ToolSelected', properties: {  toolName } })
    occlusalPlaneActor.setVisibility(occlusalPlaneVisible && nextTool == ToolID.OrientationAdjustment);

    if (nextTool == ToolID.OrientationAdjustment) {
      if (normalMeshes.length == 1 && selectedActor == null) {
        setSelectedActor(normalMeshes[0].actor);
      } else if (normalMeshes.length > 1 && selectedActor == null) {
        normalMeshes.forEach((mesh) => {
          if (mesh.name == MeshName.Mandibular || mesh.name == MeshName.MandibularAnatomy) {
            console.log('set default selected mesh');
            setSelectedActor(mesh.actor);
            return;
          }
        });
      }
    }
    console.log('selected tool:', ToolID[nextTool]);
  };

  const handleClick = (tool: string) => {
    console.log('selected tool:', tool);
  };

  const classes = useStyles();
  const tr = new Tr();

  const getOccluIcon = () => {
    if (ToolID.OcclusionMapping === currentTool) {
      return <OcclusionMappingSelectIcon />;
    }
    return <OcclusionMappingIcon />;
  };

  return (
    <div className={classes.toolbar}>
      <MuiThemeProvider theme={theme}>
        <StyledToggleButtonGroup
          orientation="vertical"
          aria-label="tool button group"
          value={currentTool}
          exclusive
          onChange={handleChange}
        >
          <TooltipToggleButton
            color="primary"
            value={ToolID.Display}
            className={classes.button}
            title={tr.titlebarDisplay()}
            name="toolbar.btnDisplay"
          >
            <DisplayIcon />
          </TooltipToggleButton>

          {withMarginLine && (
            <TooltipToggleButton
              color="primary"
              value={ToolID.MarginLine}
              className={classes.button}
              title={tr.titlebarMarginLine()}
              name="toolbar.btnMarginLine"
            >
              <MarginLineIcon />
            </TooltipToggleButton>
          )}

          <TooltipToggleButton
            color="primary"
            value={ToolID.OrientationAdjustment}
            className={classes.button}
            title={tr.titlebarOrientationAdjustment()}
            name="toolbar.btnOrientationAdjustment"
          >
            <OrientationAdjustIcon />
          </TooltipToggleButton>

          {withBuccalBite && occluAvailable && (
            <TooltipToggleButton
              color="primary"
              value={ToolID.OcclusionMapping}
              className={classes.button}
              title={tr.titlebarOcclusionMapping()}
              name="toolbar.btnOcclusionMapping"
            >
              {getOccluIcon()}
            </TooltipToggleButton>
          )}

          <TooltipToggleButton
            color="primary"
            value={ToolID.Gallery}
            className={classes.button}
            title={tr.titlebarGallery()}
            name="toolbar.btnGallery"
          >
            <GalleryIcon />
          </TooltipToggleButton>
        </StyledToggleButtonGroup>
      </MuiThemeProvider>

      {exportAvailable && (
        <TooltipButton
        title={tr.titlebarExport()}
        className={classes.button}
        placement="right"
        imgSrc={ExportIcon}
        onClick={() => setExportOpen(true)}
        name="toolbar.btnExport"
      />
      )}
      

      <div className={classes.spacer}></div>

      <TooltipButton
        title={tr.titlebarImageInfo()}
        className={classes.button}
        placement="right"
        imgSrc={MenuIcon}
        onClick={() => setImageInfoOpen(true)}
        name="toolbar.btnImageInfo"
      />

      <TooltipButton
        title={tr.titlebarAbout()}
        className={classes.button}
        placement="right"
        imgSrc={InfoIcon}
        onClick={() => {
          setAboutOpen(true);
        }}
        name="toolbar.btnInfo"
      />

      <TooltipButton
        title={tr.titlebarHelp()}
        className={classes.button}
        placement="right"
        imgSrc={HelpIcon}
        onClick={() => handleClick('help')}
        name="toolbar.btnHelp"
      />
      <ExportDlg open={exportOpen} onClose={() => setExportOpen(false)} />
      {aboutOpen && <AboutDlg open={aboutOpen} onClose={() => setAboutOpen(false)} />}
      {imageInfoOpen && <ImageInfoDlg open={imageInfoOpen} onClose={() => setImageInfoOpen(false)} />}
      <BusyDlg open={busyDlgProp.visible} title={busyDlgProp.title} />
    </div>
  );
};

export default ToolBar;
